import { isBackendDateTimeInFuture } from 'modules/core/lib/dates'
import { Model } from 'modules/core/lib/mobx-rest'

enum Topics {
  Message = 'message',
  SentOfferLetter = 'sent_offer_letter',
  DeclinedOfferLetter = 'declined_offer_letter',
}

export interface Attachment {
  url: string
  content_type: string
  filename: string
  byte_size: number
}

interface IMessage {
  id: number
  content: string
  ats_conversation_id: number
  sent_by_id: number
  sent_by_type: string
  created_at: string
  attachments: Attachment[]
  topic: string
  delayed_until: string
  sent_at: string
  delivered_at: string
  opened_at: string
  last_error_at: string
}

class Message extends Model<IMessage> {
  static urlRoot() {
    return '/ats/messages'
  }

  get attachments(): Attachment[] {
    return this.toJS().attachments
  }

  get isDeclinedOfferTopic(): boolean {
    return this.attributes.topic === Topics.DeclinedOfferLetter
  }

  get isSentOfferTopic(): boolean {
    return this.attributes.topic === Topics.SentOfferLetter
  }

  get isDelayed(): boolean {
    return isBackendDateTimeInFuture(this.attributes.delayed_until)
  }

  cancel(): Promise<void> {
    return this.rpc('cancel')
  }
}

export default Message
